<template>
    <div class="users-list">
        <vuestic-widget :headerText="$t('users.profile.title')">
            <dl v-if="user" class="row">
                <dt class="col-sm-3">{{ $t('users.name') }}</dt>
                <dd class="col-sm-9">{{ user.name }}</dd>

                <dt class="col-sm-3">{{ $t('users.email') }}</dt>
                <dd class="col-sm-9">{{ user.email }}</dd>

                <dt class="col-sm-3">{{ $t('users.role') }}</dt>
                <dd class="col-sm-9">{{ user.role }}</dd>

                <template v-if="!admin">
                    <dt class="col-sm-3 text-truncate">{{ $t('users.org') }}</dt>
                    <dd class="col-sm-9">
                        <span v-if="user.organization">{{ user.organization.name }}</span>
                    </dd>
                </template>
            </dl>
            <div class="pt-2">
                <button v-on:click="editUserProfile" class="btn btn-sm btn-warning">
                    {{ $t('buttons.edit') }}
                </button>
                <button v-on:click="cancel" class="btn btn-sm btn-primary ml-1">
                    {{ $t('buttons.cancel') }}
                </button>
            </div>
        </vuestic-widget>
    </div>
</template>

<script>
import HTTP from '../../services/http'
import VuesticWidget from '../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget'

export default {
  name: 'UserProfile',
  components: { VuesticWidget },
  data () {
    return {
      user: {},
    }
  },
  created () {
    this.getUser()
  },
  computed: {
    // admin user
    admin () {
      return this.$store.getters['auth/admin']
    },
  },
  methods: {
    /**
     * Get user data
     */
    getUser () {
      HTTP.get(`users/profile`)
        .then(response => {
          this.user = response.data.user
        })
    },

    /**
     * Edit user profile
     */
    editUserProfile () {
      this.$router.push({ name: 'users.profile.edit' })
    },

    /**
     * Return to index page
     */
    cancel () {
      this.$router.push({ name: 'index' })
    },
  },
}
</script>
